import React from 'react'
import { getGridStringOperators } from '@mui/x-data-grid-pro'
import { Tooltip, Typography } from '@mui/material'

import { QuestionListColumnType } from '../questionListDataGridColumns'

export const topicColumnModel: QuestionListColumnType = {
  field: 'topicTitle',
  width: 150,
  filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals'),
  sortable: false,
  filterable: false,
  valueGetter: (params) => params.row?.topic?.texts?.title || '',
  renderCell: (params) => {
    const title = params.row?.topic?.texts?.title || ''

    return (title
      ? <Tooltip title={title}>
        <Typography
          variant="subtitle1"
          fontWeight={500}
        >
          {title}
        </Typography>
      </Tooltip>
      : <Typography variant="subtitle1" fontWeight={500}>-</Typography>
    )
  }
}
